<template>
  <div
    v-if="canSeeAlert"
    :class="alertClass"
    class="rb-alert mt-1 rounded-bottom d-flex align-items-center"
  >
    <i
      v-if="isPending"
      class="fas fa-hourglass-half fa-flip font-24 icon-sand-animate mx-3 ml-lg-2"
    ></i>
    <i
      v-if="isCompleted"
      class="fas fa-check-circle font-24 icon-complete mx-3 ml-lg-2"
    ></i>
    <img
      v-if="isRunning"
      class="rb-loading"
      src="@/assets/img/loading.svg"
      alt=""
      srcset=""
    />
    <i
      v-if="isFailed || isFailedTimeout"
      class="fas fa-hourglass-half font-24 mx-3 ml-lg-2"
      style="margin-left: 1rem"
    />
    <p
      v-if="isPending"
      class="font-weight-normal my-auto"
      :class="isMobile ? 'font-12' : 'font-14'"
    >
      Su informe está pendiente de generación. Oprima
      <a
        class="text-dark-yellow text-undeline font-weight-bold cursor-pointer"
        @click="cancelHandler"
      >
        <strong>aquí</strong>
      </a>
      para cancelar esta acción.
    </p>

    <p
      v-if="isRunning"
      class="font-weight-normal my-auto"
      :class="isMobile ? 'font-12' : 'font-14'"
    >
      Su informe está siendo generado. Una vez finalizado, aparecerá un enlace
      para descargarlo. Oprima
      <a
        class="text-dark-yellow text-undeline font-weight-bold cursor-pointer"
        @click="cancelHandler"
      >
        <strong>aquí</strong>
      </a>
      para cancelar esta acción.
    </p>

    <p
      v-if="isFailedTimeout"
      class="font-weight-normal my-auto"
      :class="isMobile ? 'font-12' : 'font-14'"
    >
      El reporte sobrepasó el tiempo máximo de ejecución, por lo cual no pudo
      ser generado, favor intentar nuevamente. Si la situación persiste favor
      contactar Asistencia MIPE.
    </p>

    <p
      v-if="isFailed"
      class="font-weight-normal my-auto"
      :class="isMobile ? 'font-12' : 'font-14'"
    >
      Durante el proceso de ejecución del reporte, se encontró una situación de
      configuración que está impidiendo generar el reporte, favor de comunicarse
      con Asistencia MIPE.
    </p>

    <p
      v-if="isCompleted"
      class="font-weight-normal my-auto"
      :class="isMobile ? 'font-12' : 'font-14'"
    >
      Su informe ha sido generado. Este archivo expirará en
      <strong>24</strong>
      horas. Oprima
      <a
        class="text-undeline font-weight-bold cursor-pointer"
        @click="downloadHandler"
      >
        <strong>aquí</strong>
      </a>
      para descargar el informe.
    </p>
  </div>
</template>

<script>
import queueReportStatus from '@/utils/constants/queueReportStatus.js'
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'
import { date } from '@/utils/filters'

export default {
  name: 'QueueReportStatus',
  components: {},
  mixins: [alertMixin],
  props: {
    queueReport: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    current: false,
  }),
  computed: {
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    formatDate() {
      return (d) => date(d)
    },
    canSeeAlert() {
      const list = [
        queueReportStatus.Pending,
        queueReportStatus.Running,
        queueReportStatus.Completed,
        queueReportStatus.Failed,
      ]
      return list.includes(this.queueReport?.statusId) && !this.queueReport.expired
    },
    alertClass() {
      const keyIndex = Object.values(queueReportStatus).indexOf(this.queueReport.statusId);
      return `alert-${Object.keys(queueReportStatus)[keyIndex].toLowerCase()}`;
    },
    isPending() {
      return this.queueReport.statusId === queueReportStatus.Pending
    },
    isRunning() {
      return this.queueReport.statusId === queueReportStatus.Running
    },
    isCompleted() {
      return this.queueReport.statusId === queueReportStatus.Completed
    },
    isFailedTimeout() {
      return (
        this.queueReport.statusId === queueReportStatus.Failed &&
        this.queueReport.statusMessage == 'Timeout'
      )
    },
    isFailed() {
      return (
        this.queueReport.statusId === queueReportStatus.Failed &&
        this.queueReport.statusMessage != 'Timeout'
      )
    },
    isInactive() {
      return this.queueReport.statusId === queueReportStatus.Inactive
    },
  },
  methods: {
    async cancelHandler() {
      const result = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea cancelar la ejecución del reporte?`,
        'Sí',
        'No'
      );

      if (result) {
        this.$emit('on-cancel', this.queueReport.executionLogId);
      }
    },
    async downloadHandler() {
      this.$emit('on-download', this.queueReport.executionLogId);
    },
  },
}
</script>

<style lang="scss" scoped>
hr.divider {
  border: 1px solid #727272;
  opacity: 0.22;
  width: 100%;
  margin-left: 1rem !important;
}

.row-container {
  z-index: 2;
  position: static;
}

.icon-topic {
  margin-top: 6px;
}

.icon-complete {
  margin-left: 1.139rem;
}

.icon-sand-animate {
  --fa-flip-x: 1;
  --fa-flip-y: 0;
  --fa-animation-duration: 2s;
}

p {
  overflow-wrap: break-word;
}

.rb-alert {
  top: 97%;
  left: 0;
  width: 100%;
  padding: 10px 0;
}

.alert-pending {
  background-color: #feeeb7;

  & p,
  i {
    color: #af6717;
  }
}

.alert-running,
.alert-failed,
.alert-canceled {
  background-color: #fdeee8;

  & p,
  i {
    color: #af4208;
  }
}

.alert-completed {
  background-color: #d0f0e0;

  & a {
    color: #0d764d;
  }

  & p,
  i {
    color: #0d764d;
  }
}

.mb-5rem {
  margin-bottom: 5rem !important;
}

.text-dark-yellow {
  color: #af6717;
}

::v-deep
  div.bg-secondary-3.border-radius--light.border--top.border-left--color-secondary-5 {
  border-left-width: 4px;
}

@media only screen and (max-width: 600px) {
  ::v-deep div.dropdown-menu {
    width: 320px !important;
  }
}
::v-deep .bg-secondary-3 {
  background-color: #fafafa;
}

.w-80 {
  width: 80% !important;
}

.rb-loading {
  -webkit-animation: spin 4s linear infinite;
  -moz-animation: spin 4s linear infinite;
  animation: spin 4s linear infinite;
  margin-left: 1.139rem;
  margin-right: 1.3rem;
}

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media (min-width: 1400px) {
  .m-right {
    margin-right: 5rem !important;
  }
}
</style>
